export const buildCartFragment = ({ responseData }) => {
  console.log(responseData)


  const { items, total_price } = responseData;
  const shippingMessgae = document.querySelector('.product .product__shipping');

  return `
    <div class="side-cart--row side-cart__title">
      <span id="SideCartCount">Your Cart</span>
      <span class="side-cart--close">
        <svg width="14px" height="12px" class="icon" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
              <g id="05-PDP-Copy-2" transform="translate(-1400.000000, -43.000000)" stroke="#000000">
                  <g id="Group" transform="translate(1401.000000, 43.000000)">
                      <path d="M0.4,0.4 L11.6285351,11.6285351" id="Line-4"></path>
                      <path d="M0.4,0.4 L11.6285351,11.6285351" id="Line-4" transform="translate(6.000000, 6.000000) rotate(-90.000000) translate(-6.000000, -6.000000) "></path>
                  </g>
              </g>
          </g>
        </svg>
      </span>
    </div>
    <div class="side-cart--scroll">

    ${items.map((item, i) => buildCartItemFragment({ ...item, i })).join('')}

    </div>
    <p class="free__shipping">${shippingMessgae.dataset.shippingMessage}</p>

    <div class="side-cart--row bottom">
      <div class="side-cart__shipping">
        <span>Shipping:</span><span>Free</span>
      </div>
      <div class="side-cart__subtotal">
        <span>Subtotal:</span><span>$${total_price / 100}</span>
      </div>
      <div class="side-cart__button">
        <a href="/cart/checkout.js" id="sideCartCheckout" name="checkout" class="btn">Checkout Now</a>
      </div>
    </div>
  `
}

const buildCartItemFragment = ({ product_title, vendor, price, image, i }) => {
  return `
    <div class="side-cart--row">
      <div class="side-cart__image">
        <img src="${image}"/>
      </div>
      <div class="side-cart__info">
        <div class="side-cart__title">${product_title}</div>
        <div class="side-cart__variant">${vendor}</div>
        <div class="side-cart__price">$${price / 100}</div>
        <button class="side-cart__remove" data-line-item="${+i + 1}">Remove</button>
      </div>
    </div>
  `
}


export function getCart() {

  const credentials = 'same-origin';
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  return window.fetch('/cart.js', { credentials, headers })
    .then(response => response.json())
    .catch((error) => {
      throw new Error(error);
    })
}

export function postCartAdd({ id, quantity }) {
  const headers = { 'Content-Type': 'application/json' };
  const credentials = 'same-origin';
  const method = 'POST';
  const body = JSON.stringify({ id, quantity });

  return window.fetch('/cart/add.js', { headers, credentials, method, body })
    .then(response => response.json())
    .catch((error) => {
      throw new Error(error);
    });
}

export function postCartChange({ line, quantity }) {

  const headers = { 'Content-Type': 'application/json' };
  const credentials = 'same-origin';
  const method = 'POST';
  const body = JSON.stringify({ line, quantity });
  console.log(body)
  return window.fetch('/cart/change.js', { headers, credentials, method, body })
    .then(response => response.json())
    .catch((error) => {
      throw new Error(error);
    });
}

export function deleteCartItem({ line }) {
  return postCartChange({ line, quantity: 0 })
}
